import React from 'react';
import { motion } from 'framer-motion';

/**
 * PageContainer - Componente padrão para todas as páginas internas
 * 
 * Props:
 * - title: Título da página (obrigatório)
 * - description: Descrição opcional da página
 * - actions: Elemento React com ações (botões, filtros, etc)
 * - children: Conteúdo da página
 * - maxWidth: Largura máxima do container (default: '7xl')
 */
const PageContainer = ({ 
  title, 
  description, 
  actions, 
  children, 
  maxWidth = '7xl' 
}) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      <div className={`max-w-${maxWidth} mx-auto px-4 sm:px-6 lg:px-8 py-8`}>
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
          className="mb-8"
        >
          <div className="flex flex-col gap-4">
            <div>
              <h1 className="text-3xl font-bold text-white mb-2">
                {title}
              </h1>
              {description && (
                <p className="text-gray-400">
                  {description}
                </p>
              )}
            </div>
            {actions && (
              <div className="flex-shrink-0">
                {actions}
              </div>
            )}
          </div>
        </motion.div>

        {/* Content */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, delay: 0.1 }}
        >
          {children}
        </motion.div>
      </div>
    </div>
  );
};

export default PageContainer;
